import Component from './DownloadUrl.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionDownloadUrl', Component);
  },
};
